import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

// 🔹 Backend’in Public Key’i (Güncellemeyi Unutma!)
const PUBLIC_KEY_PEM = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAkhRFTUf2WUmRaUrzXkhn
CeYcrNPbhjtMpC+msRCZEXp0zrmDf6T6xM/qCNGdNFAFRC8LU9mYvS9BBMH9xjbQ
d3C0UXaU4jYathcs8jJNTyDRBjXsGfbmlOjWzaU5LpEAEC9u4+KBA9XQMOVE2Zdx
KDiB9kcWeAd/sjl6GdOI+3lVC10SMaqLasEygV/jONE59/HBj2JWb5OqH1AcuR03
UOmdRy+kncJoGCFk0KFtTrJHqK/5cVqEXkDKc3gvM4eqIVfbJtxuDS1AR7/L/hWF
yGpXbqChqGr0pRqwOtqcNO+rT52P5Jxedl8Dp35eTAacuT14s4o/ZX6pW656TeNc
0wIDAQAB
-----END PUBLIC KEY-----`;

/**
 * Veriyi AES ile şifreleyip, AES Key’i RSA ile şifreler
 * @param {Object} obj - Gönderilecek JSON nesnesi
 * @returns {Object} - Şifrelenmiş veri ve şifrelenmiş AES anahtarı
 */
export const encryptRequest = (obj) => {
  // 1️⃣ Rastgele AES Key Oluştur
  const aesKey = CryptoJS.lib.WordArray.random(32);
  const aesKeyBase64 = CryptoJS.enc.Base64.stringify(aesKey);  // Base64 formatına çevir

  // 2️⃣ Veriyi AES ile ECB Modunda Şifrele
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(obj),
    aesKey, // Key doğrudan WordArray formatında olmalı
    {
      mode: CryptoJS.mode.ECB,  // 🔥 ECB Modu
      padding: CryptoJS.pad.Pkcs7,  // 🔥 PKCS7 Padding
    }
  ).toString();

  // 3️⃣ AES Key’i RSA Public Key ile Şifrele (JSEncrypt Kullanarak)
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(PUBLIC_KEY_PEM);
  const encryptedAESKey = encryptor.encrypt(aesKeyBase64); // Base64 formatında gönderiyoruz!

  return {
    encryptedData,
    encryptedAESKey, // RSA ile şifrelenmiş AES Key
    aesKeyBase64 // AES Key, yanıtı çözerken lazım olacak
  };
};

/**
 * Gelen cevabı AES ile çözer
 * @param {Object} response - API'den gelen yanıt
 * @param {string} aesKeyBase64 - Daha önce oluşturduğumuz AES Key
 * @returns {Object} - Çözülmüş JSON nesnesi
 */
export const decryptResponse = (responseEncryptedData, aesKeyBase64) => {
  // Base64 ile gelen AES key'ini decode et
  const aesKey = CryptoJS.enc.Base64.parse(aesKeyBase64);

  // Response şifreli verisini Base64 decode et
  const encryptedData = CryptoJS.enc.Base64.parse(responseEncryptedData);

  // AES ile deşifreleme işlemi
  const decryptedBytes = CryptoJS.AES.decrypt(
    { ciphertext: encryptedData },
    aesKey,
    { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 } // ECB ve PKCS7 padding
  );

  // Decrypted data'yı string olarak al
  const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);

  // JSON formatında döndür
  return JSON.parse(decryptedData);
};

export const produceAESKey = () => {
  const aesKey = CryptoJS.lib.WordArray.random(32);
  const aesKeyBase64 = CryptoJS.enc.Base64.stringify(aesKey);  // Base64 formatına çevir

  // 3️⃣ AES Key’i RSA Public Key ile Şifrele (JSEncrypt Kullanarak)
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(PUBLIC_KEY_PEM);
  const encryptedAESKey = encryptor.encrypt(aesKeyBase64); // Base64 formatında gönderiyoruz!

  return {
    aesKeyBase64,
    encryptedAESKey
  };
}